import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQuery } from '..';
import { LocationShape, LocationsResponseShape } from 'models/locations';

export const LocationsApi = createApi({
  reducerPath: 'locationsApi',
  tagTypes: ['locations', 'location'],
  baseQuery,
  endpoints: (builder) => ({
    getLocationsData: builder.query<LocationsResponseShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['locations'],
    }),
    getLocation: builder.query<LocationShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['location'],
    }),
  }),
});

export const { useGetLocationsDataQuery, useGetLocationQuery } = LocationsApi;
